<template>
  <div class="buyerCenter">
      <a-breadcrumb separator=">" class="breadcrumb">
      <a-breadcrumb-item>
        <a @click.prevent="$router.push('/index')">首页</a>
      </a-breadcrumb-item>
      <a-breadcrumb-item>
       {{$route.meta.title}}
      </a-breadcrumb-item>
    </a-breadcrumb>
    <div class="mainbody">
      <Each/>
      <div class="view">
      <router-view /></div>
    </div>
  </div>
</template>
      
<script>
import Each from "./components/Each.vue";
export default {
  components: {
    Each
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.buyerCenter {
  max-width: 1440px;
  min-width: 990px;
  @media screen and (max-width:1440px){
    padding: 0 15px;
  }
  margin: auto;
  margin-bottom: 64px;
  box-sizing: border-box;
  .mainbody {
    outline: 1px solid #e8e8e8;
    display: flex;
    justify-content: space-between;
    .view {
      width: calc(100% - 250px);
      background: #fff;
    }
  }
  .breadcrumb{
    width: 100%;
    min-width: 960px;
    font-size: 14px;
  }
}
</style>